export const categories = [
  {
    slug: 'juqing-xiang',
    name: '剧情向里番',
    description: '以深刻剧情和人物塑造见长的里番作品，故事情节丰富，角色关系复杂，适合追求叙事体验的观众。',
    icon: 'ri-film-line',
    color: 'primary',
  },
  {
    slug: 'xiaoyuan-ticai',
    name: '校园题材',
    description: '以校园生活为背景的里番作品，涵盖学园恋爱、青春成长等元素，贴近年轻观众的日常体验。',
    icon: 'ri-building-2-line',
    color: 'accent',
  },
  {
    slug: 'qihuan-ticai',
    name: '奇幻题材',
    description: '融合魔法、异世界、超自然等奇幻元素的里番作品，想象力丰富，世界观宏大。',
    icon: 'ri-magic-line',
    color: 'secondary',
  },
  {
    slug: 'jingdian-heji',
    name: '经典合集',
    description: '历年来备受好评的经典里番动漫作品合集，包括口碑佳作与业界标杆。',
    icon: 'ri-star-line',
    color: 'primary',
  },
  {
    slug: 'zuixin-fabu',
    name: '最新发布',
    description: '追踪最新上线的里番动漫作品，第一时间获取新番资讯与观看指南。',
    icon: 'ri-fire-line',
    color: 'accent',
  },
  {
    slug: 're-men-tuijian',
    name: '热门推荐',
    description: '当下最受欢迎和讨论度最高的里番动漫作品精选推荐。',
    icon: 'ri-thumb-up-line',
    color: 'secondary',
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || categories[0];
};